'use client'

import { memo, useEffect, useState } from 'react'
import type { FC, PropsWithChildren, ReactNode } from 'react'

import { Catalog } from '@/features/catalog'

import CatalogProdCardV2 from '@/components/catalog/CatalogProdCardCatalogV2'
import Header from '@/components/header/Header'
import { LoadMoreButton } from '@/modules/CatalogV2/components/LoadMoreButton'
import FooterSection from '@/modules/CatalogModule/components/FooterSection/FooterSection'
import { PageContainer } from '@/shared/PageContainer'
import Footer from '@/components/Footer/Footer'
import type { TNotFoundProps } from '@/features/catalog/model'
import { Categories } from './components/Categories'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { setCurrentCatalogCategory } from '@/redux/features/catalogSlice'
import { useGetInitialCategoriesQuery } from '@/redux/services/catalogApi'
import { Breadcrumbs } from './components/Breadcrumbs'
import { selectList } from '@/assets/data/filter'
import Filter from '@/components/filter/Filter'
import { Loader } from '@/features/catalog/ui/Loader'
import CatalogSortCurtain from '@/components/catalog/CatalogSortCurtain'
import { catalogSlice } from '@/features/catalog/model/catalogSlice'

const CatalogWrapper: FC<PropsWithChildren> = ({ children }: { children?: ReactNode }) => {
    return <div className='catalog__products'>{children}</div>
}

const ListWrapper: FC<PropsWithChildren> = ({ children }: { children?: ReactNode }) => {
    return <ul className='catalog__products-list'>{children}</ul>
}

const NotFound: FC<TNotFoundProps> = ({ text }) => {
    return <div>{text}</div>
}

interface ICatalogPageProps {
    catalogParams: string[] | null
    filters: any
    animalTypes: any
}

export const CatalogPage = memo(function CatalogPage({ catalogParams, filters, animalTypes }: ICatalogPageProps) {
    const dispatch = useAppDispatch()
    const { currentCatalogCategory } = useAppSelector(state => state.catalogv1)
    const [curtainOpen, setCurtainOpen] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [sort, setSort] = useState('id')

    const { data: categories } = useGetInitialCategoriesQuery()

    useEffect(() => {
        if (currentCatalogCategory?.length) {
            return
        } else {
            if (categories && categories.length) {
                dispatch(setCurrentCatalogCategory(categories))
            }
        }
    }, [categories])

    const catalogSliceState = useAppSelector(state => {
        return state.catalog
    })

    console.log(catalogSliceState.editableFilter)

    return (
        <PageContainer className='catalog__wrapper'>
            <Header
                burgerBg={'#f3f6fe'}
                isWhiteLogo={true}
            />
            <section className='catalog container'>
                <Breadcrumbs />
                <Categories
                    animalTypes={animalTypes}
                    list={currentCatalogCategory}
                />
                <section className='catalog__products'>
                    <div className='catalog__products-content'>
                        <div></div>
                        <div></div>
                        <Filter
                            curtainOpen={curtainOpen}
                            setCurtainOpen={state => setCurtainOpen(state)}
                            selectList={selectList}
                            setSearchValue={setSearchValue}
                            sort={sort}
                            setSort={setSort}
                        />
                        <CatalogSortCurtain
                            curtainOpen={curtainOpen}
                            setCurtainOpen={state => setCurtainOpen(state)}
                            filters={filters}
                            catalogParams={catalogParams}
                        />
                        <Catalog
                            sort={sort}
                            setSort={setSort}
                            setSearchValue={setSearchValue}
                            searchValue={searchValue}
                            categories={categories}
                            filters={filters ? filters : undefined}
                            catalogParams={catalogParams}
                            CatalogWrapper={CatalogWrapper}
                            ListWrapper={ListWrapper}
                            notFoundText={'По вашему запросу ничего не найдено'}
                            ItemCard={CatalogProdCardV2}
                            countPerPage={10}
                            LoadMoreButton={LoadMoreButton}
                            Loader={Loader}
                            NotFound={NotFound}
                        />
                    </div>
                    <div></div>
                    {/* <CatalogSort
                        animalTypesData={animalTypes}
                        filters={filters}
                    /> */}
                </section>
            </section>
            <FooterSection
                page={0}
                count={10}
            />
            <Footer mapTheme='light' />
        </PageContainer>
    )
})
